import 'cally'
import NextButton from "@/components/NextButton";
import CalendarIcon from "@/components/icons/CalendarIcon";
import {useAppState} from "@/store";
import StepTitles from "@/components/StepTitles";
import {apiUrl, dataLayerPush} from "@/helpers";
import {useValidation} from "@/validation";
import StepFooter from "@/components/StepFooter";
import {API_ENDPOINTS} from "@/constants";
import {useApi} from "@/api";
import Calendar from "@/components/fields/Calendar";
import {toast} from "react-toastify";
import {useEffect} from "react";
import Panel from "@/components/Panel";
import ChoiceMulti from "@/components/fields/ChoiceMulti";

export default function DatePicker({goToStep}) {

    const {state, setState} = useAppState()
    const {api, setLoading} = useApi();
    const {preSubmitValidate} = useValidation()

    const handleSubmit = async () => {
        setLoading(true)

        try {
            preSubmitValidate()
            const response = await api.post(apiUrl(API_ENDPOINTS.date), {
                "requestId": state.requestId,
                "preferredDate": state.preferred_date.raw,
                "flexibility": state.preferred_date.flexibility,
            })

            setState((s) => {
                s.inestimable['date'] = response.inestimable?.status  ? response.inestimable?.reasons : false
            })

            await dataLayerPush('book-date-time-submit', {
                ['book-date-initial-select']: state.preferred_date.raw,
                ['book-assigned-branch']: state.branch?.name || null
            })

            goToStep(4)
        } catch (e) {
            toast.error(e.message)
        }
        setLoading(false)
    }

    useEffect(() => {
        dataLayerPush('book-date-time-view', {
            ['book-assigned-branch']: state.branch?.name || null
        }).then()
    }, [])


    const content = window.ein?.content?.step_3 || {}

    const {title, secondary_title, tertiary_title, button_label} = content

    return (
        <div className={"grid grid-cols-4 lg:grid-cols-12 gap-x-[20px] lg:gap-x-[32px] gap-y-[40px]"}>
            <div className="col-span-4 lg:col-span-12 flex flex-col items-center text-center">
                <CalendarIcon className={'size-[80px] mb-[16px]'}/>
                <StepTitles title={title} secondaryTitle={secondary_title} tertiaryTitle={tertiary_title}/>
            </div>
            <div className="col-span-4 lg:col-span-8 lg:col-start-3">
                <Calendar />
            </div>
            <div className="col-span-4 lg:col-span-12 ">
                <Panel passive={true}>
                    <div className="heading-h4 text-center">
                        Any wiggle room on your date?
                    </div>
                    <div className={"text-center italic text-brand-grey text-sm mt-[4px]"}>
                        If your first-choice day is full, knowing your flexibility helps us find you the next best slot.
                    </div>
                    <ChoiceMulti
                        stateKey={"preferred_date"}
                        name={"flexibility"}
                        labels={[
                            <>📌 Nope, this is the day</>,
                            <>🗓️ A few days either way</>,
                            <>🤙 Pretty flexible — no rush</>
                        ]}
                        values={[
                            "none",
                            "few_days",
                            "flexible"
                        ]}
                    />
                </Panel>
            </div>
            <div className="col-span-4 lg:col-span-12 flex justify-center">
                <NextButton onClick={handleSubmit} text={button_label} disabled={false} />
            </div>
            <div className="col-span-4 lg:col-span-12">
                <StepFooter/>
            </div>
        </div>
    )
}
